module.exports = __webpack_public_path__ + "img/pic-2.63ec319e.png";